import React, { useEffect, useRef, useState } from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-jsx";
/*eslint-disable no-alert, no-console */

import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/ext-language_tools";

const languages = (window.languages && Object.keys(window.languages)) || [];

const themes = [
  "monokai",
  "github",
  "tomorrow",
  "kuroir",
  "twilight",
  "xcode",
  "textmate",
  "solarized_dark",
  "solarized_light",
  "terminal"
];

languages.forEach(lang => {
  require(`ace-builds/src-noconflict/mode-${lang}`);
});

// eslint-disable-next-line
const snippetManager = ace.require("ace/snippets").snippetManager;
// eslint-disable-next-line
const config = ace.require("ace/config");

languages.forEach(lang => {
  // eslint-disable-next-line
  ace.define(`ace/snippets/${lang}`,["require","exports","module"], function(require, exports, module) {
    "use strict";
    exports.snippetText = "";
    exports.scope = lang;
    const parseSnippets = window.languages[lang].snippetText ? snippetManager.parseSnippetFile(window.languages[lang].snippetText) : [];
    exports.snippets = [...parseSnippets, ...(window.languages[lang].snippets || [])];
    snippetManager.register(exports.snippets, exports.scope);
  });                
  (function() {
    // eslint-disable-next-line
    ace.require([`ace/snippets/${lang}`], function(m) {
      if (typeof module == "object" && typeof exports == "object" && module) {
        module.exports = m;
      }
    });
  })();
});

themes.forEach(theme => require(`ace-builds/src-noconflict/theme-${theme}`));

export const Editor = ({value, onValueChange, mode = "csharp", theme = "monokai", fontSize = 14, basicAuto = true, liveAuto = true, snippets = true, maxHeight = "60vh"}) => {

  const editor = useRef();

  const [state, setState] = useState({
    value,
    placeholder: "",
    theme: theme,
    mode,
    enableBasicAutocompletion: basicAuto,
    enableLiveAutocompletion: liveAuto,
    fontSize: fontSize,
    showGutter: true,
    showPrintMargin: true,
    highlightActiveLine: true,
    enableSnippets: snippets,
    showLineNumbers: true
  });

/*
  useEffect(()=>{

    if(window.languages){
      Object.keys(window.languages).forEach(mode => {
        config.loadModule(`ace/snippets/${mode}`, function(m) {
          if (m) {
            m.snippets = [...(m.snippets || []), ...(extraSnippets || [])];
            snippetManager.register(m.snippets, m.scope);
          }
        });
      })
    }
  }, [])
*/
  useEffect(()=>{
    onValueChange(state.value);
  }, [state.value])

  const onLoad = (editorInstance) => {
  }

  const onChange = (newValue) => {
    setState(state => ({
      ...state,
      value: newValue
    }));
  }

  const onValidate = (annotations) => {
    //console.log("onValidate", annotations);
  }

  const setTheme = (e) => {
    setState(state => ({
      ...state,
      theme: e.target.value
    }));
  }

  const setMode = (e) => {
    setState(state => ({
      ...state,
      mode: e.target.value
    }));
  }

  const setBoolean = (name, value) => {
    setState(state => ({
      ...state,
      [name]: value
    }));
  }

  const setFontSize = (e) => {
    setState(state => ({
      ...state,
      fontSize: parseInt(e.target.value, 10)
    }));
  }
  
    return (
      <>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="form-inline">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">Tema</span>
              </div>
              <select
                className="form-control"
                name="Theme"
                onChange={setTheme}
                value={state.theme}
              >
                {themes.map(theme => (
                  <option key={theme} value={theme}>
                    {theme}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-group pl-2">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">Tamaño</span>
              </div>
              <select
                  name="FontSize"
                  className="form-control"
                  onChange={setFontSize}
                  value={state.fontSize}
                >
                  {[14, 16, 18, 20, 24, 28, 32, 40].map(size => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
            </div>
            <div className="input-group pl-2">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">Modo</span>
              </div>
              <select
                  name="mode"
                  className="form-control"
                  onChange={setMode}
                  value={state.mode}
                >
                  {languages.map(lang => (
                    <option key={lang} value={lang}>
                      {lang}
                    </option>
                  ))}
                </select>
            </div>

            <div className="input-group pl-2">
              <input
                type="checkbox"
                checked={state.enableBasicAutocompletion}
                id="enableBasicAutocompletion"
                onChange={e =>
                  setBoolean(
                    "enableBasicAutocompletion",
                    e.target.checked
                  )
                }
              />
              <label class="form-check-label" for="enableBasicAutocompletion">
                Autocompletar básico
              </label>
            </div>

            <div className="input-group pl-2">
              <input
                type="checkbox"
                checked={state.enableLiveAutocompletion}
                id="enableLiveAutocompletion"
                onChange={e =>
                  setBoolean(
                    "enableLiveAutocompletion",
                    e.target.checked
                  )
                }
              />
              <label class="form-check-label" for="enableLiveAutocompletion">
                Autocompletar live
              </label>
            </div>

            <div className="input-group pl-2">
              <input
                type="checkbox"
                checked={state.enableSnippets}
                id="enableSnippets"
                onChange={e =>
                  setBoolean(
                    "enableSnippets",
                    e.target.checked
                  )
                }
              />
              <label class="form-check-label" for="enableSnippets">
                Snippets
              </label>
            </div>
          </div>
        </nav>

        <AceEditor
        debounceChangePeriod={350}
          style={{ maxHeight }}
          focus={true}
          width = "100%"
          height = "1500px"
          wrapEnabled={true}
          placeholder={state.placeholder}
          mode={state.mode}
          theme={state.theme}
          name="editor"
          onChange={onChange}
          //onLoad={onLoad}
          //onValidate={onValidate}
          value={state.value}
          fontSize={state.fontSize}
          showPrintMargin={state.showPrintMargin}
          showGutter={state.showGutter}
          highlightActiveLine={state.highlightActiveLine}
          setOptions={{
            useWorker: true,
            enableBasicAutocompletion: state.enableBasicAutocompletion,
            enableLiveAutocompletion: state.enableLiveAutocompletion,
            enableSnippets: state.enableSnippets,
            showLineNumbers: state.showLineNumbers,
            tabSize: 2
          }}
        />
      </>
    );
}

